export default "__VITE_ASSET__BNwQDMGR__"